/**
 * Created by spepa on 10/05/20
 */

const PaintBrush = function (photos) {
    this.photos = photos;
    this.side = this.determineSide();
    this.addPaint();
    this.gatherItems();
};

PaintBrush.prototype.isInPaintArea = function (object, side) {
    const paintArea = cleverapps.styles.PaintBrush;
    const pos = this.getAreaPos(side);

    const areaRect = cc.rect(pos.x - paintArea.width / 2, pos.y - paintArea.height / 2, paintArea.width, paintArea.height);
    const objectRect = cc.rect(object.x - object.width / 2, object.y - object.height / 2, object.width, object.height);
    return cc.rectIntersectsRect(objectRect, areaRect);
};

PaintBrush.prototype.cloversToGather = function () {
    const cloversToGather = [];

    this.photos.clovers.forEach(function (clover) {
        if (this.isInPaintArea(clover)) {
            cloversToGather.push(clover);
        }
    }, this);

    return cloversToGather.sort((a, b) => (a.y < b.y ? 1 : -1));
};

PaintBrush.prototype.getAreasToOpen = function () {
    return this.areasToOpen.sort((a, b) => (a.y < b.y ? 1 : -1));
};

PaintBrush.prototype.determineSide = function () {
    const left = [];
    const right = [];

    this.photos.differences.getUndiscoveredAreas().forEach(function (area) {
        const areaData = PhotoViews.FrameSizeAndPos(area);
        if (this.isInPaintArea(areaData, PaintBrush.RIGHT_SIDE)) {
            right.push(area);
        }
        if (this.isInPaintArea(areaData, PaintBrush.LEFT_SIDE)) {
            left.push(area);
        }
    }, this);

    if (left.length < right.length) {
        this.areasToOpen = left;
        return PaintBrush.LEFT_SIDE;
    } 
    this.areasToOpen = right;
    return PaintBrush.RIGHT_SIDE;
};

PaintBrush.prototype.getAreaPos = function (side, areaWidth) {
    const photoSize = this.photos.getPhotoSize();
    areaWidth = areaWidth || cleverapps.styles.PaintBrush.width;
    side = side !== undefined ? side : this.side;

    if (side === PaintBrush.RIGHT_SIDE) {
        return cc.p(photoSize.width - areaWidth / 2, photoSize.height / 2);
    } 
    return cc.p(areaWidth / 2, photoSize.height / 2);
};

PaintBrush.prototype.gatherItems = function () {
    const clovers = this.cloversToGather();
    const cloversStep = PaintBrush.LOOPE_TIME / clovers.length;
    const areas = this.getAreasToOpen();
    const areasStep = PaintBrush.LOOPE_TIME / areas.length;

    clovers.forEach((clover, ind) => {
        clover.runAction(new cc.Sequence(
            new cc.DelayTime(cloversStep * (ind + 1)),
            new cc.CallFunc(() => {
                clover.cloverFound();
            })
        ));
    });

    areas.forEach(function (area, ind) {
        this.photos.runAction(new cc.Sequence(
            new cc.DelayTime(areasStep * (ind + 1)),
            new cc.CallFunc(() => {
                this.photos.differences.discover(area);
            })
        ));
    }, this);
};

PaintBrush.prototype.addPaint = function () {
    this.photos.runAction(new cc.Sequence(
        new cc.DelayTime(2),
        new cc.CallFunc(() => {
            cleverapps.effects.fire("differences.brush.paint");
        })
    ));

    [this.photos.imageA, this.photos.imageB].forEach(function (parent) {
        const paintArea = new cc.Node();
        paintArea.setAnchorPoint(0.5, 0.5);
        paintArea.setAlignment(this.getAreaPos());
        paintArea.setContentSize2(cleverapps.styles.PaintBrush);
        parent.addChild(paintArea, 2);

        const paint = new cleverapps.Spine(bundles.game.jsons.brush_paint_json);
        paintArea.addChild(paint);
        paint.setAlignment(paintArea.width / 2, paintArea.height / 2);

        const blockPhotoClickHandler = cleverapps.UI.onClick(paintArea, () => {}, {});
        paintArea.runAction(new cc.Sequence(
            new cc.CallFunc(() => {
                paint.setAnimation(0, this.side === PaintBrush.LEFT_SIDE ? "brush" : "brush2", false);
            }),
            new cc.DelayTime(2.3),
            new cc.CallFunc(() => {
                blockPhotoClickHandler.remove();
                cleverapps.tooltipManager.create(paintArea, {
                    text: Messages.get("PaintAreaTooltip"),
                    location: cleverapps.UI.Tooltip.LOCATION_ABOVE
                });
            })
        ));
    }, this);
};

PaintBrush.LEFT_SIDE = 0;
PaintBrush.RIGHT_SIDE = 1;
PaintBrush.LOOPE_TIME = 1.5;

cleverapps.styles.PaintBrush = {
    width: 450,
    height: 600
};